/**
 * The invitation token, taken out of the address bar the first time it is read.
 *
 * It is a bearer credential — 256 bits from `secrets` — and whoever holds it
 * can join the organisation. The address bar is the one place a credential
 * must not stay: it is what a person screenshots when they ask a colleague
 * for help, it is a history entry that syncs across their devices, and it is
 * the `Referer` on the next outbound link they click.
 *
 * `loc` and `hist` are arguments rather than `window.location` and
 * `window.history` so the caller states which browser it means, and so this
 * module holds no reference to a global it could read again later. It stores
 * nothing: the single returned string is the only copy, and the page that asks
 * for it owns its lifetime.
 */

export function takeTokenFromLocation(loc: Location, hist: History): string | null {
  const params = new URLSearchParams(loc.search);
  const token = params.get('token');
  if (token === null) return null;

  params.delete('token');
  const query = params.toString();
  // `replaceState`, never `pushState`: a pushed entry would leave the address
  // carrying the token one Back press away.
  hist.replaceState(null, '', `${loc.pathname}${query === '' ? '' : `?${query}`}${loc.hash}`);

  return token === '' ? null : token;
}
